import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

export const collectionApi = {
  async listCollections(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/collections', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async uploadProofOfPayment(file) {
    const formData = new FormData();
    formData.append('file', file);

    const { accessToken } = getStoredAuth();
    const response = await apiClient.post('/collections/proof-of-payment/upload', formData, {
      headers: {
        Accept: 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    });

    return response.data;
  },

  async postArPayment(payload) {
    const response = await apiClient.post('/collections/post-ar-payment', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async cancelAr(payload) {
    const response = await apiClient.post('/collections/cancel-ar', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async listCommissionRates(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/commission-rates', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async listBankRemittances(options = {}) {
    const { bustCache = false } = options;
    const response = await apiClient.get('/bank-remittances', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async uploadDepositSlip(file) {
    const formData = new FormData();
    formData.append('file', file);

    const { accessToken } = getStoredAuth();
    const response = await apiClient.post('/bank-remittances/deposit-slip/upload', formData, {
      headers: {
        Accept: 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    });

    return response.data;
  },

  async createBankRemittance(payload) {
    const response = await apiClient.post('/bank-remittances', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updateBankRemittance(bankRemittanceId, payload) {
    const response = await apiClient.put(`/bank-remittances/${bankRemittanceId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async cancelBankRemittance(bankRemittanceId, payload) {
    const response = await apiClient.post(`/bank-remittances/${bankRemittanceId}/cancel`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async deleteBankRemittance(bankRemittanceId) {
    const response = await apiClient.delete(`/bank-remittances/${bankRemittanceId}`, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },
};

export function resolveCollectionApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process collections request.');
}
